export default "__VITE_PUBLIC_ASSET__c840f91e__"